// Single source of truth for the legal-entity details shown across the site
// (LegalFooter, Terms, Refund, Grievance, Privacy). Keep every legally-required
// identifier here so the footer and the policy pages can never drift apart.

export const LEGAL_ENTITY = {
  name: 'Nethaji Digital Media Private Limited',
  brand: 'Nethaji Prime',
  cin: 'U60200TN2026PTC190003',
  address: 'No. 29, G Floor, Akbarabad 2nd Street, Kodambakkam, Chennai, Tamil Nadu 600024',
  supportEmail: 'contact@nethajiprime.com',
  supportPhone: '+91 94444 56788',
  website: 'nethajiprime.com',
  grievanceOfficerName: 'R. Varadaraj',
  grievanceEmail: 'contact@nethajiprime.com',
  grievanceResponseDays: 15,
};

// The four legal pages, in the order the footer lists them. `hash` gives each a
// stable, directly-linkable URL (e.g. https://nethajiprime.com/#terms) that a
// payment-gateway reviewer can be pointed at.
export const LEGAL_PAGES = [
  { key: 'terms', hash: '#terms', label: 'Terms & Conditions' },
  { key: 'privacy', hash: '#privacy', label: 'Privacy Policy' },
  { key: 'refund', hash: '#refund', label: 'Refund & Cancellation' },
  { key: 'grievance', hash: '#grievance', label: 'Grievance Redressal' },
];
